import React from 'react'

import { fetchInterviewTemplate } from 'api/interviewTemplates'

// NOTE: hook that gathers all the data fetching handlers
// and exposes them for local hooks
export const useQueries = () => {
  const handleFetchTemplates = React.useCallback(
    async ({ uuid }) => await fetchInterviewTemplate({ uuid }),
    [],
  )

  return { handleFetchTemplates }
}
